function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as v } from "react/jsx-runtime";
import { useTheme as c } from "../../hooks.js";
import { useIsInverseVariant as i } from "../../theme-variant-context.js";
import { vars as e } from "../../skins/skin-contract.css-mistica.js";
const n = (_param)=>{
    var { color: o , size: h = 24  } = _param, m = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = i(), r = o !== null && o !== void 0 ? o : t ? e.colors.inverse : e.colors.neutralHigh, { skinName: a  } = c();
    return a.match(/^o2/i) ? /* @__PURE__ */ v("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, m), {
        children: /* @__PURE__ */ v("path", {
            fill: r,
            d: "M5.348 2h13.297c.4 0 .717.326.722.73V22h-9.345v-5.454H8.223v5.45H4.63V2.725c0-.4.322-.726.718-.726zm6.11 18.544h6.469V3.456H6.066v17.088h.717V15.09h4.675v5.454zm-4.675-7.455h4.675V9.818H6.783v3.27zm3.594-2.178V12H7.86v-1.089h2.517zm2.157 2.178h4.675V9.818h-4.675v3.27zm3.594-2.178V12H13.61v-1.089h2.517zm-3.594 7.45h4.675V15.09h-4.675v3.271zm3.594-2.182v1.089H13.61v-1.09h2.517zM6.783 8.003h4.675V4.727H6.783v3.276zm3.594-2.183v1.09H7.86V5.82h2.517zm2.157 2.183h4.675V4.727h-4.675v3.276zm3.594-2.183v1.09H13.61V5.82h2.517z"
        })
    })) : /* @__PURE__ */ v("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, m), {
        children: /* @__PURE__ */ v("path", {
            fill: r,
            d: "M17.999 21.846H5.996c-.737 0-1.38-.644-1.38-1.378V3.541c0-.723.658-1.378 1.38-1.378H18c.723 0 1.38.658 1.38 1.378v16.927c-.002.734-.646 1.378-1.38 1.378zm-8.258-1.204V16.25c0-.334.266-.603.591-.603h3.328c.328 0 .591.27.591.603v4.389h3.745c.098 0 .196-.112.196-.174V3.538c-.005-.059-.123-.174-.196-.174H5.993c-.075 0-.193.113-.196.174v16.927c0 .062.101.174.196.174l3.748.003zm3.328-.031v-3.76h-2.143v3.76h2.143zM8.817 7.269V5.911h1.336v1.358H8.817zm-.591 1.205h2.52a.597.597 0 00.592-.603V5.308a.595.595 0 00-.591-.602H8.226a.597.597 0 00-.591.602v2.563c0 .334.263.603.59.603zm5.571-1.205V5.911h1.336v1.358h-1.336zm-.59 1.205h2.52a.597.597 0 00.591-.603V5.308a.595.595 0 00-.59-.602h-2.522a.597.597 0 00-.59.602v2.563c0 .334.263.603.59.603zM8.816 12.3v-1.359h1.336V12.3H8.817zm-.591 1.204h2.52a.597.597 0 00.592-.602V10.34a.595.595 0 00-.591-.602h-2.52a.597.597 0 00-.591.602v2.563c0 .334.263.603.59.603zm5.571-1.204v-1.359h1.336V12.3h-1.336zm-.59 1.204h2.52a.597.597 0 00.591-.602V10.34a.595.595 0 00-.59-.602h-2.522a.597.597 0 00-.59.602v2.563c0 .334.263.603.59.603z"
        })
    }));
}, H = n;
export { H as default };
